<template>
  <Modal :name="$options.name"
         :is-loading="isLoading"
         title="Nyomtatás">
    <template v-if="printOptions.length > 0"
              #body>
      <div v-for="(parentItem, parentCheckboxIndex) in printOptions"
           :key="`inspectionPrintModalPrinterParent_${parentCheckboxIndex}`">
        <b-field>
          <b-checkbox @input="parentCheckboxChanged(parentCheckboxIndex, $event)"
                      v-model="printList[parentCheckboxIndex].checked"
                      :native-value="parentItem.inspection_type_id"
                      class="has-text-weight-bold">
            {{ parentItem.inspection_type }}
          </b-checkbox>
        </b-field>
        <b-field v-for="(childItem, childCheckboxIndex) in parentItem.options"
                 :key="`inspectionPrintModalPrinter_${childCheckboxIndex}`"
                 class="ml-5">
          <b-checkbox v-model="printList[parentCheckboxIndex].options[childCheckboxIndex].checked"
                      @input="childCheckboxChanged(parentCheckboxIndex, childCheckboxIndex, $event)"
                      :native-value="childItem.id">
            {{ childItem.name }}
          </b-checkbox>
        </b-field>
      </div>
    </template>
    <template #footer>
      <b-button type="is-primary"
                :disabled="!hasCheckedItems"
                @click="print">
        Nyomtatás
      </b-button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modals/common/BasicModal'
import { has } from 'immutable'

export default {
  name: 'InspectionPrintModal',
  components: {
    Modal,
  },
  data () {
    return {
      printOptions: [],
      printList: [],
      isLoading: false,
    }
  },
  methods: {
    has,
    childCheckboxChanged (parentIndex, childIndex, value) {
      this.printList[parentIndex].checked = this.printList[parentIndex].options.every(option => option.checked)
    },
    parentCheckboxChanged (index, value) {
      this.printList[index].options.forEach(option => {
        option.checked = value
      })
    },
    closeModal () {
      this.$store.dispatch('closeModal', this.$options.name)
      this.printList = []
      this.printOptions = []
    },
    async print () {
      if (this.hasCheckedItems) {
        this.isLoading = true
        const resp = await this.$store.dispatch('printInspection', {
          inspectionID: this.inspectionID,
          printOptions: this.printList.map(item => {
            return {
              inspection_type_id: item.inspection_type_id,
              options: item.options.filter(option => option.checked).map(option => option.id),
            }
          }).filter(item => item.options.length > 0).flat(),
        })
        if (resp) {
          this.closeModal()
        }
      } else {
        this.$buefy.toast.open({
          message: 'Nincs kiválasztva elem!',
          type: 'is-danger',
        })
      }
      this.isLoading = false
    },
  },
  computed: {
    inspectionID () {
      return this.$store.state.modal.modalPayloadData[this.$options.name]?.inspectionID
    },
    hasCheckedItems () {
      return this.printList.some(parent =>
        parent.checked || parent.options.some(child => child.checked),
      )
    },
  },
  watch: {
    async inspectionID (newValue) {
      if (newValue) {
        this.isLoading = true
        this.printOptions = await this.$store.dispatch('fetchPrintInspectionOptions', newValue)
        this.printList = this.printOptions.map(item => {
          return {
            inspection_type_id: item.inspection_type_id,
            checked: false,
            options: item.options.map(option => {
              return {
                id: option.id,
                checked: false,
              }
            }),
          }
        }).flat()
        console.log(this.printOptions, this.printList)
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>

</style>
